export const state = {
  addDevice: {},
  updateDevice: {},
  device: {
    deviceId: '',
    deviceName: '',
    phoneNumber: '',
    userName: '',
    userId: '',
    personalDeviceFlag: '',
    callAppDivision: '1'
  },
  devices: [],
  exportData: [],
  total: 0,
  selectedDeviceList: []
}
export const mutations = {
  setDevices(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedDeviceList.some(
          selectedDevice =>
            selectedDevice.deviceId === response.data['data'][i]['deviceId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
      let date = new Date(response.data['data'][i]['createDateTime'])
      response.data['data'][i]['createDateTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      date = new Date(response.data['data'][i]['lastUpdateDateTime'])
      response.data['data'][i]['lastUpdateDateTime'] =
        response.data['data'][i]['lastUpdateDateTime'] === null
          ? ''
          : date.getFullYear() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getDate() +
            ' ' +
            date.toLocaleTimeString()
    }
    state.devices = response.data['data']
    state.total = response.data['header']['total']
  },
  setExportData(state, response) {
    for (var i = 0; i < response.data['data'].length; i++) {
      let date = new Date(response.data['data'][i]['createDateTime'])
      response.data['data'][i]['createDateTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      date = new Date(response.data['data'][i]['lastUpdateDateTime'])
      response.data['data'][i]['lastUpdateDateTime'] =
        response.data['data'][i]['lastUpdateDateTime'] === null
          ? ''
          : date.getFullYear() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getDate() +
            ' ' +
            date.toLocaleTimeString()
    }
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    let date = new Date(response.data['data'][i]['createDateTime'])
    response.data['data'][0]['createDateTime'] =
      date.getFullYear() +
      '/' +
      (date.getMonth() + 1) +
      '/' +
      date.getDate() +
      ' ' +
      date.toLocaleTimeString()
    date = new Date(response.data['data'][i]['lastUpdateDateTime'])
    response.data['data'][0]['lastUpdateDateTime'] =
      response.data['data'][i]['lastUpdateDateTime'] === null
        ? ''
        : date.getFullYear() +
          '/' +
          (date.getMonth() + 1) +
          '/' +
          date.getDate() +
          ' ' +
          date.toLocaleTimeString()
    state.device = response.data['data'][0]
    state.updateDevice = {}
    state.updateDevice.deviceId = state.device.deviceId
  },
  inputUpdate(state, payload) {
    state.updateDevice[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addDevice[payload.name] = payload.value
  },
  clearDevice(state) {
    state.addDevice = {}
    var defaultCallAppDivision = 1
    state.addDevice.callAppDivision = defaultCallAppDivision
  },
  changePersonalDeviceFlag(state, payload) {
    state.addDevice.personalDeviceFlag = payload
    state.updateDevice.personalDeviceFlag = payload
  },
  updateSelectedDeviceList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedDeviceList.some(
          device => device.deviceId === payload[i].deviceId
        )
      ) {
        state.selectedDeviceList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedDeviceList.some(
          device => device.deviceId === payload[i].deviceId
        )
      ) {
        const deleteIndex = state.selectedDeviceList.findIndex(
          device => device.deviceId === payload[i].deviceId
        )
        state.selectedDeviceList = state.selectedDeviceList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedDeviceList(state) {
    state.selectedDeviceList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/deviceModules/deviceMutation.js